import React from 'react';
import { Navbar } from '../components/layout/navbar';
import { HeroSection } from '../components/sections/heroSection';
import { IndividualSection } from '../components/sections/individualSection';
import { BusinessSection } from '../components/sections/businessSection';
import { FeaturesSection } from '../components/sections/feturesSection';
import { TestimonialsSection } from '../components/sections/testimonialsSection';
import { ContactSection } from '../components/sections/contactSection';
import { Footer } from '../components/layout/Footer';
import { FloatingAssistant } from '../components/layout/floatingAssistant';
import { PricingSection } from '../components/sections/pricingSection';
import { ExtensionInstallSection } from '../components/sections/extensionInstallSection';
import { UniversalHero } from '../components/sections/universalHero';
import { Building, ChartArea } from 'lucide-react';


// Types


// Context pour le thème

const BusinessPage: React.FC = () => {
    return (
        <div className="bg-white dark:bg-gray-900 transition-colors duration-300">
            <Navbar />
            <UniversalHero
                pageName="business"
                breadcrumbs={[
                    { name: "Solutions", href: "/" },
                    { name: "Business", href: "/solutions/business" }
                ]}
                customConfig={{
                    title: "Solutions pour les entreprises",
                    subtitle: "Boostez la productivité de votre équipe",
                    description: "Découvrez nos outils pensés pour la collaboration, l'efficacité et la croissance des entreprises modernes.",
                    primaryColor: "bg-gradient-to-r from-purple-600 to-pink-600 ",
                    secondaryColor: "from-cyan-500 to-emerald-400",
                    icon: ChartArea,
                    badge: "Nouveau pour les pros",
                    backgroundPattern: "waves",
                    cta: {
                        text: "Demander une démo",
                        link: "/contact",
                        secondary: {
                            text: "En savoir plus",
                            link: "/solutions"
                        }
                    }
                }}
            />
            <BusinessSection />
            <Footer />
            <FloatingAssistant />
        </div>
    );
}
export default BusinessPage;
